export const VALUE_DRIVER = '@driver/VALUE_DRIVER';
export type VALUE = typeof VALUE_DRIVER;

export interface SetValueDriver {
  type: VALUE;
  payload: {
    valueDriver: null,
  }
}

export function setValueDriver(valueDriver: any): SetValueDriver {
  return {
    type: VALUE_DRIVER,
    payload: {
      valueDriver: valueDriver
    }
  };
}